module.exports = __webpack_public_path__ + "img/catalogHouseware.c995fce6.jpg";